var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAlertEnable)?_c('div',{staticClass:"md-tabs-navigation"},[_c('md-badge',{attrs:{"md-content":_vm.quantityProducts}},[_c('md-button',{on:{"click":_vm.openStock}},[_vm._v("Sous-Stock")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }